import Employee from './Employee';
import General from './General';
import Company from './Company';

const signup = {
  namespaced: true,
  modules: {
    Employee,
    General,
    Company,
  },
};

export default signup;
